(() => {
  const ACCEPT_SELECTOR = '#shopify-pc__banner__btn-accept';
  const DECLINE_SELECTOR = '#shopify-pc__banner__btn-decline';
  const MANAGE_PREFS_SELECTOR = '#shopify-pc__banner__btn-prefs';
  const PREFS_DIALOG_SELECTOR = '#shopify-pc__prefs__dialog';
  const PREFS_ACCEPT_SELECTOR = '#shopify-pc__prefs__header-accept';
  const PREFS_SAVE_SELECTOR = '#shopify-pc__prefs__header-save';
  const PREFS_WAIT_TIMEOUT_LONG = 15000;
  const PREFS_VISIBILITY_DELAY_MS = 0;

  const LABELS_BY_LANGUAGE = {
     en: { accept: 'Accept all', decline: 'Decline all', manage: 'Manage preferences' },
     pt: { accept: 'Aceitar tudo', decline: 'Rejeitar tudo', manage: 'Gerir preferências' },
  };
  const getLanguage = () => ((document.documentElement.lang || 'en').toLowerCase().startsWith('pt') ? 'pt' : 'en');
  const getLabels = () => LABELS_BY_LANGUAGE[getLanguage()];

  const waitForElement = (selector, timeout = 3000, interval = 100) => new Promise((resolve) => {
    const end = Date.now() + timeout;
    (function check() {
      const el = document.querySelector(selector);
      if (el) return resolve(el);
      if (Date.now() > end) return resolve(null);
      setTimeout(check, interval);
    })();
  });

  const waitForDialogClose = async (dialog, timeout = 1000) => {
    const end = Date.now() + timeout;
    while (document.body.contains(dialog) && Date.now() < end) await new Promise(r => setTimeout(r, 50));
    return !document.body.contains(dialog);
  };

  const triggerClick = (el) => {
    if (!el) return;
    try {
      if (typeof el.focus === 'function') el.focus();
      if (typeof el.click === 'function') {
        el.click();
        return;
      }
      el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    } catch (e) {}
  };

  const closeBanner = () => {
    try {
      const banner = document.querySelector('.shopify-pc__banner, [data-shopify-pc-banner], #shopify-pc__banner');
      if (banner) {
        try { banner.style.display = 'none'; } catch (e) {}
        try { banner.remove(); } catch (e) {}
      }
    } catch (e) {}
  };

  const syncBannerLabels = () => {
    const banner = document.querySelector('.shopify-pc__banner, [data-shopify-pc-banner], #shopify-pc__banner');
    if (!banner) return;

    const labels = getLabels();
    const acceptButton = banner.querySelector(ACCEPT_SELECTOR);
    const declineButton = banner.querySelector(DECLINE_SELECTOR);

    if (acceptButton && (acceptButton.textContent || '').trim() !== labels.accept) {
      acceptButton.textContent = labels.accept;
    }

    if (declineButton && (declineButton.textContent || '').trim() !== labels.decline) {
      declineButton.textContent = labels.decline;
    }
  };

  const hidePrefsDialog = (dialog) => {
    if (!dialog) return;
    try {
      dialog.style.opacity = '0';
      dialog.style.visibility = 'hidden';
      dialog.style.pointerEvents = 'none';
    } catch (e) {}
  };

  const handleAcceptAllClick = (event) => {
    const target = event.target;

    if (target && typeof target.closest === 'function' && target.closest(PREFS_DIALOG_SELECTOR)) return;

    const acceptButtonById = document.querySelector(ACCEPT_SELECTOR);

    let isAcceptClick = false;
    if (acceptButtonById && acceptButtonById.contains(target)) isAcceptClick = true;
    else {
      const nearby = target.closest('button, a');
      if (nearby) {
        const txt = (nearby.textContent || '').trim();
        const labels = getLabels();
        if (txt && (txt === labels.accept || txt.toLowerCase().includes(labels.accept.toLowerCase()))) isAcceptClick = true;
        if (!txt && nearby.id && `#${nearby.id}` === ACCEPT_SELECTOR) isAcceptClick = true;
      }
    }
    if (!isAcceptClick) return;

    const marker = acceptButtonById || target.closest('button, a');
    if (marker && marker.dataset && marker.dataset.acceptHandled) return;
    if (marker && marker.dataset) marker.dataset.acceptHandled = 'true';

    event.preventDefault();
    event.stopImmediatePropagation();

    let managePrefsBtn = document.querySelector(MANAGE_PREFS_SELECTOR);
    if (!managePrefsBtn) {
      const labels = getLabels();
      managePrefsBtn = Array.from(document.querySelectorAll('button, a')).find((el) => {
        const txt = (el.textContent || '').trim().toLowerCase();
        return txt === (labels.manage || 'manage preferences').toLowerCase();
      });
    }

    if (!managePrefsBtn) {
      if (marker) triggerClick(marker);
      return;
    }

    triggerClick(managePrefsBtn);

    (async () => {
      const dialog = await waitForElement(PREFS_DIALOG_SELECTOR, PREFS_WAIT_TIMEOUT_LONG, 100) || await waitForElement('[role="dialog"], [role="alertdialog"]', PREFS_WAIT_TIMEOUT_LONG, 100);
      if (!dialog) {
        const defaultAccept = document.querySelector(ACCEPT_SELECTOR);
        if (defaultAccept) {
          if (defaultAccept.dataset) defaultAccept.dataset.acceptHandled = 'true';
          triggerClick(defaultAccept);
        }
        return;
      }

      const prefsAcceptBtn = dialog.querySelector(PREFS_ACCEPT_SELECTOR) || Array.from(dialog.querySelectorAll('button, a')).find((el) => {
        const txt = (el.textContent || '').trim();
        return txt && txt.toLowerCase() === getLabels().accept.toLowerCase();
      });
      const saveBtn = dialog.querySelector(PREFS_SAVE_SELECTOR) || Array.from(dialog.querySelectorAll('button, a')).find((el) => {
        const txt = (el.textContent || '').trim().toLowerCase();
        return txt === 'save' || txt === 'guardar' || txt === 'salvar';
      });

      const toClick = prefsAcceptBtn || saveBtn;
      if (!toClick) {
        const anyBtn = Array.from(dialog.querySelectorAll('button, a')).find((el) => {
          const txt = (el.textContent || '').trim().toLowerCase();
          return txt && (txt.includes('accept') || txt.includes('save') || txt.includes('aceitar') || txt.includes('guardar') || txt.includes('salvar'));
        });
        if (anyBtn) {
          if (anyBtn.dataset) anyBtn.dataset.acceptHandled = 'true';
          await new Promise(r => setTimeout(r, PREFS_VISIBILITY_DELAY_MS));
          triggerClick(anyBtn);
          hidePrefsDialog(dialog);
          closeBanner();
          return;
        }

        const defaultAccept2 = document.querySelector(ACCEPT_SELECTOR);
        if (defaultAccept2) { if (defaultAccept2.dataset) defaultAccept2.dataset.acceptHandled = 'true'; triggerClick(defaultAccept2); closeBanner(); }
        return;
      }

      if (toClick.dataset) toClick.dataset.acceptHandled = 'true';
      await new Promise(r => setTimeout(r, PREFS_VISIBILITY_DELAY_MS));
      triggerClick(toClick);

      hidePrefsDialog(dialog);
      closeBanner();
    })();
  };

  // attach listener
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.addEventListener('click', handleAcceptAllClick, true);
      syncBannerLabels();
      new MutationObserver(syncBannerLabels).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    document.body.addEventListener('click', handleAcceptAllClick, true);
    syncBannerLabels();
    new MutationObserver(syncBannerLabels).observe(document.body, { childList: true, subtree: true });
  }
})();
